export default {
    mobile: '@media screen and (max-width: 767px)',
    tablet: '@media screen and (max-width: 1023px)',
    desktop: '@media screen and (max-width: 1439px)',
    fullWidth: '@media screen and (min-width: 1440px)'
}
  